import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkspace } from "@/contexts/WorkspaceContext";

export const WorkspaceRedirect = () => {
  const { currentWorkspaceId, isLoading } = useWorkspace();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && currentWorkspaceId) {
      navigate(`/${currentWorkspaceId}/agents`, { replace: true });
    }
  }, [currentWorkspaceId, isLoading, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-muted-foreground">Loading workspace...</div>
    </div>
  );
};

